import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export function useMetaPixel() {
  useEffect(() => {
    // Avoid initializing twice
    if (window.fbq) return

    const f = window
    const b = document
    const n = 'script'

    const fbq = function (...args: any[]) {
      if ((fbq as any).callMethod) {
        ;(fbq as any).callMethod.apply(fbq, args)
      } else {
        ;(fbq as any).queue.push(args)
      }
    } as any

    if (!f.fbq) {
      f.fbq = fbq
      fbq.push = fbq
      fbq.loaded = true
      fbq.version = '2.0'
      fbq.queue = []

      const e = b.createElement(n) as HTMLScriptElement
      e.async = true
      e.src = 'https://connect.facebook.net/en_US/fbevents.js'
      const s = b.getElementsByTagName(n)[0]
      s?.parentNode?.insertBefore(e, s)
    }

    window.fbq = fbq
    window.fbq('init', '1269466825117329')
    window.fbq('track', 'PageView')
  }, [])
}
